module.exports = __webpack_public_path__ + "media/images/back-crowd-9945cb9f.jpg";